/// <amd-module name="Wiki/Renderer/MentionSyntaxProcessor" />
import { ICustomSyntaxProcessor } from "VSS/Features/Markdown/Interfaces/ICustomSyntaxProcessor";
import { ILegacyPlatformService } from "VSS/Legacy/Legacy";
import { IVssPageContext } from "VSS/Platform/Context";

/**
 * Thin Wrapper over the legacy MentionSyntaxProcessor
 */
export class MentionSyntaxProcessor implements ICustomSyntaxProcessor {
    private _legacyMentionSyntaxProcessorPromise: Promise<ICustomSyntaxProcessor>;

    constructor(pageContext: IVssPageContext) {
        const legacyPlatformService = pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");
        this._legacyMentionSyntaxProcessorPromise = legacyPlatformService
            .requireModules([
                "Mention/Scripts/MentionSyntaxProcessor",
                "Mention/Scripts/TFS.Mention.WorkItems.Registration", // To register work-item mention parser and provider
                "Mention/Scripts/TFS.Mention.People.Registration" // To register people mention parser and provider
            ])
            .then(([mentionSyntaxProcessorModule]) => {
                return new mentionSyntaxProcessorModule.MentionSyntaxProcessor();
            });
    }

    public preProcess(markdown: string): Promise<string> {
        return this._legacyMentionSyntaxProcessorPromise.then(mentionSyntaxProcessor => mentionSyntaxProcessor.preProcess(markdown));
    }

    public postProcess(markup: string): Promise<string> {
        return this._legacyMentionSyntaxProcessorPromise.then(mentionSyntaxProcessor => mentionSyntaxProcessor.postProcess(markup));
    }
}
